module.exports = __webpack_public_path__ + "img/yrtpro_android.fe5a59a2.png";